// extracted by mini-css-extract-plugin
export default {"img":"styles_img__nVrIi","tooltipContainer":"styles_tooltipContainer__7y0gg"};